import React from 'react';

// import { Container } from './styles';

const Loader = ({
  color = '#66cad8',
  style = { height: '3.5rem', width: '3.5rem' },
}) => (
  <div className="rotating">
    <svg
      viewBox="0 0 179.474 179.474"
      height="64px"
      width="64px"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g
        className="ldl-scale"
        style={{
          transformOrigin: '50% 50%',
          transform: 'rotate(0deg) scale(0.8, 0.8)',
        }}
      >
        <g
          className="ldl-ani"
          style={{
            transformOrigin: '89.737px 89.737px',
            transform: 'rotate(0deg)',
            animation:
              '1.35135s linear 0s infinite normal forwards running spin-cbac095a-5c73-4682-b7d7-48111ddc860b',
          }}
        >
          <g className="ldl-layer">
            <g className="ldl-ani">
              <g transform="translate(-1372.737 -346.907)" id="grafismo_dono">
                <g className="ldl-layer">
                  <g className="ldl-ani">
                    <path
                      fill={color}
                      d="M1489.061,416.33a9.571,9.571,0,0,0-1.861,7.869l.046.293,56.323-.033a8.382,8.382,0,0,0,6.625-2.751,8.9,8.9,0,0,0,2.017-5.914,12.732,12.732,0,0,0-.155-1.956l-.046-.293-56.322.034a8.383,8.383,0,0,0-6.627,2.751"
                      data-name="Caminho 6954"
                      id="Caminho_6954"
                      style={{ fill: color }}
                    />
                  </g>
                </g>
                <g className="ldl-layer">
                  <g className="ldl-ani">
                    <path
                      fill={color}
                      d="M1466.909,403.479a9.564,9.564,0,0,0,4.249,6.88l.239.175,39.8-39.848a8.388,8.388,0,0,0,2.74-6.632,8.908,8.908,0,0,0-2.756-5.608,12.827,12.827,0,0,0-1.493-1.273l-.239-.175-39.8,39.85a8.387,8.387,0,0,0-2.739,6.631"
                      data-name="Caminho 6955"
                      id="Caminho_6955"
                      style={{ fill: color }}
                    />
                  </g>
                </g>
                <g className="ldl-layer">
                  <g className="ldl-ani">
                    <path
                      fill={color}
                      d="M1442.159,410.057a9.571,9.571,0,0,0,7.869,1.861l.293-.046-.032-56.322a8.387,8.387,0,0,0-2.752-6.626,8.9,8.9,0,0,0-5.913-2.017,12.743,12.743,0,0,0-1.957.156l-.293.046.034,56.322a8.378,8.378,0,0,0,2.751,6.626"
                      data-name="Caminho 6956"
                      id="Caminho_6956"
                      style={{ fill: color }}
                    />
                  </g>
                </g>
                <g className="ldl-layer">
                  <g className="ldl-ani">
                    <path
                      fill={color}
                      d="M1429.309,432.209a9.57,9.57,0,0,0,6.88-4.249l.175-.239-39.848-39.8a8.388,8.388,0,0,0-6.632-2.74,8.9,8.9,0,0,0-5.608,2.756,12.843,12.843,0,0,0-1.274,1.493l-.174.239,39.849,39.8a8.388,8.388,0,0,0,6.632,2.74"
                      data-name="Caminho 6957"
                      id="Caminho_6957"
                      style={{ fill: color }}
                    />
                  </g>
                </g>
                <g className="ldl-layer">
                  <g className="ldl-ani">
                    <path
                      fill={color}
                      d="M1435.887,456.959a9.569,9.569,0,0,0,1.861-7.869l-.046-.294-56.323.033a8.387,8.387,0,0,0-6.625,2.751,8.9,8.9,0,0,0-2.017,5.914,12.627,12.627,0,0,0,.156,1.957l.046.292,56.322-.033a8.384,8.384,0,0,0,6.626-2.751"
                      data-name="Caminho 6958"
                      id="Caminho_6958"
                      style={{ fill: color }}
                    />
                  </g>
                </g>
                <g className="ldl-layer">
                  <g className="ldl-ani">
                    <path
                      fill={color}
                      d="M1458.038,469.808a9.565,9.565,0,0,0-4.249-6.88l-.239-.175-39.8,39.849a8.382,8.382,0,0,0-2.739,6.631,8.9,8.9,0,0,0,2.755,5.608,12.947,12.947,0,0,0,1.493,1.274l.239.174,39.8-39.849a8.388,8.388,0,0,0,2.74-6.632"
                      data-name="Caminho 6959"
                      id="Caminho_6959"
                      style={{ fill: color }}
                    />
                  </g>
                </g>
                <g className="ldl-layer">
                  <g className="ldl-ani">
                    <path
                      fill={color}
                      d="M1482.788,463.231a9.567,9.567,0,0,0-7.869-1.86l-.293.045.032,56.323a8.39,8.39,0,0,0,2.752,6.626,8.9,8.9,0,0,0,5.913,2.016,12.746,12.746,0,0,0,1.957-.155l.293-.046-.033-56.322a8.387,8.387,0,0,0-2.752-6.627"
                      data-name="Caminho 6960"
                      id="Caminho_6960"
                      style={{ fill: color }}
                    />
                  </g>
                </g>
                <g className="ldl-layer">
                  <g className="ldl-ani">
                    <path
                      fill={color}
                      d="M1495.638,441.08a9.564,9.564,0,0,0-6.88,4.249l-.175.239,39.848,39.8a8.384,8.384,0,0,0,6.632,2.739,8.9,8.9,0,0,0,5.608-2.755,12.836,12.836,0,0,0,1.273-1.493l.175-.239-39.849-39.8a8.388,8.388,0,0,0-6.632-2.74"
                      data-name="Caminho 6961"
                      id="Caminho_6961"
                      style={{ fill: color }}
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </div>
);

export default Loader;
